import { HttpResponse } from '@angular/common/http';
import { toObjetMaquette } from '@app/features/editeur/models/commands/command';
import { ObjetMaquetteDetail } from '@pcscol/odf-api-v1-angular';
import { map } from 'rxjs/operators';

/**
 * Décorateur permettant de transformer l'objet d'api en ObjetMaquette
 * Cela en récupérant la version depuis le header http ETag
 *
 */
export function ResponseToObjetMaquetteVersion() {
    return (target: unknown, propertyKey: string, descriptor: PropertyDescriptor) => {
        const originalMethod = descriptor.value;
        descriptor.value = function(...args) {
            return originalMethod.call(this, ...args).pipe(map((om: HttpResponse<ObjetMaquetteDetail>) => toObjetMaquette(om)));
        };
        return descriptor;
    };
}
